<template>
    <fragment>
        <h1>{{ title }}</h1>
        <section><slot></slot></section>
    </fragment>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
h1 {
    font-family: "Oswald", sans-serif;
    font-size: 30px;
    text-transform: uppercase;
}
section {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 8px;
}
</style>



// WEBPACK FOOTER //
// Tab.vue?512af95e